import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Showcase = ({
  size,
  type,
  theme,
  className,
  dataTestId = "showcase-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        d="M4.738.881a1.65 1.65 0 0 0-1.65 1.65v.652h-.867a1.65 1.65 0 0 0-1.65 1.65v7.085c0 .912.738 1.65 1.65 1.65h.87a1.65 1.65 0 0 0 1.647 1.55h7.536a1.65 1.65 0 0 0 1.647-1.55h.87a1.65 1.65 0 0 0 1.65-1.65V4.833a1.65 1.65 0 0 0-1.65-1.65h-.867v-.652a1.65 1.65 0 0 0-1.65-1.65H4.738ZM2.221 4.483h.867v7.785h-.867a.35.35 0 0 1-.35-.35V4.833a.35.35 0 0 1 .35-.35Zm11.703 0v7.785h.867a.35.35 0 0 0 .35-.35V4.833a.35.35 0 0 0-.35-.35h-.867ZM4.388 2.531a.35.35 0 0 1 .35-.35h7.536a.35.35 0 0 1 .35.35V13.47a.35.35 0 0 1-.35.35H4.738a.35.35 0 0 1-.35-.35V2.53Zm2.029 3.84a1.074 1.074 0 1 0 0-2.147 1.074 1.074 0 0 0 0 2.147Zm5.286 2.878h-6.36v-1.3h6.36v1.3Zm-6.36 2.469h3.729v-1.3h-3.73v1.3Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M.506 0h16v16h-16z" />
      </clipPath>
    </defs>
  </SVGIcon>
);
